module.exports = __webpack_public_path__ + "static/img/activity-2.c84e6f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity-2.png
// module id = C00O
// module chunks = 1